import React, { ReactNode } from "react";
import { Button } from "react-md";
import MCard from "components/Shared/MCard";
import { WebOrderCase, WebOrderStatusResponse } from "interfaces/Mueller.Business.Models";

interface Props {
  orderSuccess: boolean;
  errorMessages: string[] | undefined;
  cases: WebOrderCase[] | undefined;
  response: WebOrderStatusResponse,
  onPrevious: (data: any) => void;
  onNewOrder: () => void;
}

const OrderResult = (props: Props) => {

  const cardTitle = props.orderSuccess ? "Thank you for your order" : "Error Processing Order";


  let elements: ReactNode[] = [];

  // If a critical import error occurs, errorCount may be 0
  if (!props.response?.errorCount && !props.response?.failed) {
    if (props.cases.length === 1) {
      elements.push(<p> {`Your order number is ${props.cases[0].controlIdNumber}. You will receive a confirmation e-mail shortly.`}</p>);
    } else {
      elements.push(<>
        <p>Your orders have been placed</p>
        {props.cases.map((c) => <p key={`order-confirm-${c.controlIdNumber}`}>{`Order #: ${c.controlIdNumber} - ${c.address}`}</p>)}
        <p>You will receive a confirmation e-mail shortly</p>
      </>);
    }
    elements.push(<Button
      primary
      raised
      onClick={props.onNewOrder}
      children="New Order"
    />);
  }

  if (props.response?.errorCount || props.response?.failed) {
    if (props.cases.length > 0) {
      elements.push(
        <>
          <p>{props.cases.length} out of {props.response.recordCount} of your orders have been placed</p>
          {props.cases.map((c) => <p key={`order-confirm-${c.controlIdNumber}`}>{`Order #: ${c.controlIdNumber} - ${c.address}`}</p>)}
          <p>You will receive a confirmation e-mail shortly</p>
        </>
      );
    }

    if (props.response?.errorCount > 0) {
      elements.push(<>
        <p>Import failed on {props.response.errorCount} out of {props.response.recordCount} cases</p>
        <p>For more assistance, contact customer service at 1-800-875-8339</p>
      </>);
    } else {
      elements.push(<>
        <p>Import failed. Please try again.</p>
        <p>For more assistance, contact customer service at 1-800-875-8339</p>
      </>);
    }

    if (props.cases.length === 0) {
      // dont want to give them the previous button if some cases imported, im worried about duplicate cases being ordered then
      elements.push(<Button
            primary
            raised
            onClick={props.onPrevious}
            children="Previous"
          />);
    } else {
      elements.push(<Button
        primary
        raised
        onClick={props.onNewOrder}
        children="New Order"
      />);
    }
  }

  return <MCard title={cardTitle}>{elements}</MCard>;
};

export default OrderResult;
